export const DEFAULT_NAVIGATION_WIDTH = 230;

export function navigationWidthBounds(containerWidth: number) {
  const available = Math.max(0, Number.isFinite(containerWidth) ? containerWidth - 1 : 0);
  // The divider may reach the edge of the reader container. The document
  // surface decides how it responds to a very narrow remaining width.
  const max = available;
  return {min: Math.min(160, max), max};
}

export function normalizeNavigationWidth(value: unknown) {
  return typeof value === 'number' && Number.isFinite(value)
    ? Math.max(0, value) : DEFAULT_NAVIGATION_WIDTH;
}

export function clampNavigationWidth(value: number, containerWidth: number) {
  const {min, max} = navigationWidthBounds(containerWidth);
  return Math.max(min, Math.min(max, normalizeNavigationWidth(value)));
}
